export default function isMobileDevice() {
  return (typeof window.orientation !== 'undefined') || (navigator.userAgent.indexOf('IEMobile') !== -1);
}



// WEBPACK FOOTER //
// ./src/components/Fullpage/utils/is-mobile.js